module.exports = __webpack_public_path__ + "img/map-1-f-food@2x.a6554e42.png";